import * as React from 'react'
import { FC, useState } from 'react'
import SpeakerModal from './SpeakerModal'
import { Faculty } from '../Programme'

const AVATAR_SIZE = 36

const SessionSpeaker: FC<Faculty> = ({
  id,
  avatar,
  fullName,
  shortProfile,
  country,
  company,
}) => {
  const [modal, setModal] = useState<Faculty>(null)

  const closeModal = () => setModal(null)
  const openModal = () =>
    setModal({ id, avatar, fullName, shortProfile, country, company })
  return (
    <>
      <SpeakerModal data={modal} onHide={closeModal} />
      <div
        className="speakerBtn d-flex align-items-center gap-2 mb-2"
        onClick={openModal}
      >
        <div
          className="speaker-image mx-1 img-fluid rounded-circle"
          style={{
            flexShrink: 0,
            backgroundImage: `url("${avatar}")`,
            width: `${AVATAR_SIZE}px`,
            height: `${AVATAR_SIZE}px`,
          }}
        />
        {/* <img
          src={avatar}
          className="rounded-circle me-2"
          height={AVATAR_SIZE}
          width={AVATAR_SIZE}
        /> */}
        <div>
          <small className="fw-bold">{fullName}</small>
          {/* <br />
          <small className="fst-italic">{shortProfile}</small> */}
          <br />
          {company && <small className="text-muted">{company}</small>}
          <br />
          {country && <small className="text-muted">{country}</small>}
        </div>
      </div>
    </>
  )
}

export default SessionSpeaker
